import { ORDER_TYPE } from "constants/order";
import { useTypeOrder } from "hooks";
import React from "react";
import { Button, ButtonGroup } from "reactstrap";

const GroupButtonOrderType = ({
  isShowBusReceiveType = false,
  currentValue,
  disabled,
  onChange,
  isCollector = true,
}) => {
  const { data: listOrderType } = useTypeOrder();

  return (
    listOrderType &&
    listOrderType.length > 0 && (
      <ButtonGroup>
        {listOrderType
          ?.filter(type =>
            isCollector
              ? true
              : String(type.value) !== String(ORDER_TYPE.COLLECTOR.value)
          )
          .map(type => (
            <Button
              key={type.value}
              className="mb-2"
              color={
                String(currentValue) === String(type.value)
                  ? "warning"
                  : "secondary"
              }
              type="button"
              disabled={disabled}
              onClick={() => onChange(type)}
            >
              {type.label}
            </Button>
          ))}
        {isShowBusReceiveType && (
          <Button
            key={4}
            className="mb-2"
            color={
              String(currentValue) === String(ORDER_TYPE.BUS_RECEIVE.value)
                ? "warning"
                : "secondary"
            }
            type="button"
            disabled={disabled}
            onClick={() => onChange({ value: ORDER_TYPE.BUS_RECEIVE.value })}
          >
            {ORDER_TYPE.BUS_RECEIVE.label}
          </Button>
        )}
      </ButtonGroup>
    )
  );
};

export const findOrderType = (cell, listOrderType) => {
  const type = listOrderType?.find(item => String(item.value) === String(cell));
  return type;
};

export default GroupButtonOrderType;
